import { SearchResult } from "../../model/search-result";
import { SearchResultProperty } from "../../model/search-result-property";

export class DataLineageSearchResult {
    eventTs: number;
    stepTypeCode: string;
    message: string;
    status: string;
    flowInstanceId: string;
    dataLineageFields: Record<string, string> = {};
    dataLineageProcessingId: string;
    dataLineageProcessingIdResult: DataLineageSearchResult = null;
    dataLineageDefinition: DataLineageDefinition = null;
    searchResultProperties: SearchResultProperty[] = [];

    constructor(properties?: SearchResultProperty[]) {
        if (properties && properties.length > 0) {
            properties.map(srp => {
                switch (srp.key) {
                    case "eventTs":
                        this.eventTs = srp.value;
                        break;
                    case "stepTypeCode":
                        this.stepTypeCode = srp.value;
                        break;
                    case "flowInstanceId":
                        this.flowInstanceId = srp.value;
                        break;
                    case "status":
                        this.status = srp.value;
                        break;
                    case "message":
                        this.message = srp.value;
                        break;
                    case "lineage":
                        try {
                            let lineageParsedData: any = JSON.parse(srp.value);
                            for (let lineageKey in lineageParsedData) {
                                if (lineageKey == 'processingId') {
                                    this.dataLineageProcessingId = lineageParsedData[lineageKey];
                                }
                                this.dataLineageFields[lineageKey] = lineageParsedData[lineageKey];
                            }
                        } catch (err) {
                            console.error(`Unable to parse data lineage data`, err);
                        }
                        break;
                    default:
                        if (srp.key != 'index' && srp.key != 'algorilla_type') {
                            this.searchResultProperties.push(srp);
                        }
                        break;
                }
            })
        }
    }
}


export class DataLineageDefinition {
    type: string;
    dataLineageFields: Record<string, string> = {};
}